import { css } from '@repo/pandacss/css';

export type PopoverPosition =
  | 'top-left'
  | 'top-right'
  | 'top-center'
  | 'bottom-left'
  | 'bottom-right'
  | 'bottom-center';

export const getPositionProps = (position: PopoverPosition) => {
  let isTopPosition = false;
  let horizontalAlignment: 'left' | 'center' | 'right' = 'right';

  switch (position) {
    case 'top-left':
      isTopPosition = true;
      horizontalAlignment = 'left';
      break;
    case 'top-center':
      isTopPosition = true;
      horizontalAlignment = 'center';
      break;
    case 'top-right':
      isTopPosition = true;
      break;
    case 'bottom-left':
      horizontalAlignment = 'left';
      break;
    case 'bottom-center':
      horizontalAlignment = 'center';
      break;
  }

  return { isTopPosition, horizontalAlignment };
};

// Tail size in px — exported so component JS can use it in anchor() calculations
export const POPOVER_TAIL_SIZE_PX = 9;

// Pre-computed class names per position so Panda's static extractor sees the literals
const tailClassNames: Record<PopoverPosition, string> = {
  'bottom-left': css({
    _before: {
      content: '[""]',
      position: 'absolute',
      left: '[16px]',
      top: '[-9px]',
      borderLeft: '[10px solid transparent]',
      borderRight: '[10px solid transparent]',
      borderBottom: '[9px solid]',
      borderBottomColor: 'neutral.lighter',
      borderTop: 'none',
    },
    _after: {
      content: '[""]',
      position: 'absolute',
      left: '[17px]',
      top: '[-8px]',
      borderLeft: '[9px solid transparent]',
      borderRight: '[9px solid transparent]',
      borderBottom: '[9px solid]',
      borderBottomColor: 'common.white',
      borderTop: 'none',
    },
  }),
  'bottom-right': css({
    _before: {
      content: '[""]',
      position: 'absolute',
      right: '[16px]',
      top: '[-9px]',
      borderLeft: '[10px solid transparent]',
      borderRight: '[10px solid transparent]',
      borderBottom: '[9px solid]',
      borderBottomColor: 'neutral.lighter',
      borderTop: 'none',
    },
    _after: {
      content: '[""]',
      position: 'absolute',
      right: '[17px]',
      top: '[-8px]',
      borderLeft: '[9px solid transparent]',
      borderRight: '[9px solid transparent]',
      borderBottom: '[9px solid]',
      borderBottomColor: 'common.white',
      borderTop: 'none',
    },
  }),
  'bottom-center': css({
    _before: {
      content: '[""]',
      position: 'absolute',
      left: '[50%]',
      transform: '[translateX(-50%)]',
      top: '[-9px]',
      borderLeft: '[10px solid transparent]',
      borderRight: '[10px solid transparent]',
      borderBottom: '[9px solid]',
      borderBottomColor: 'neutral.lighter',
      borderTop: 'none',
    },
    _after: {
      content: '[""]',
      position: 'absolute',
      left: '[50%]',
      transform: '[translateX(-50%)]',
      top: '[-8px]',
      borderLeft: '[9px solid transparent]',
      borderRight: '[9px solid transparent]',
      borderBottom: '[9px solid]',
      borderBottomColor: 'common.white',
      borderTop: 'none',
    },
  }),
  'top-left': css({
    _before: {
      content: '[""]',
      position: 'absolute',
      left: '[16px]',
      bottom: '[-9px]',
      borderLeft: '[10px solid transparent]',
      borderRight: '[10px solid transparent]',
      borderTop: '[9px solid]',
      borderTopColor: 'neutral.lighter',
      borderBottom: 'none',
    },
    _after: {
      content: '[""]',
      position: 'absolute',
      left: '[17px]',
      bottom: '[-8px]',
      borderLeft: '[9px solid transparent]',
      borderRight: '[9px solid transparent]',
      borderTop: '[9px solid]',
      borderTopColor: 'common.white',
      borderBottom: 'none',
    },
  }),
  'top-right': css({
    _before: {
      content: '[""]',
      position: 'absolute',
      right: '[16px]',
      bottom: '[-9px]',
      borderLeft: '[10px solid transparent]',
      borderRight: '[10px solid transparent]',
      borderTop: '[9px solid]',
      borderTopColor: 'neutral.lighter',
      borderBottom: 'none',
    },
    _after: {
      content: '[""]',
      position: 'absolute',
      right: '[17px]',
      bottom: '[-8px]',
      borderLeft: '[9px solid transparent]',
      borderRight: '[9px solid transparent]',
      borderTop: '[9px solid]',
      borderTopColor: 'common.white',
      borderBottom: 'none',
    },
  }),
  'top-center': css({
    _before: {
      content: '[""]',
      position: 'absolute',
      left: '[50%]',
      transform: '[translateX(-50%)]',
      bottom: '[-9px]',
      borderLeft: '[10px solid transparent]',
      borderRight: '[10px solid transparent]',
      borderTop: '[9px solid]',
      borderTopColor: 'neutral.lighter',
      borderBottom: 'none',
    },
    _after: {
      content: '[""]',
      position: 'absolute',
      left: '[50%]',
      transform: '[translateX(-50%)]',
      bottom: '[-8px]',
      borderLeft: '[9px solid transparent]',
      borderRight: '[9px solid transparent]',
      borderTop: '[9px solid]',
      borderTopColor: 'common.white',
      borderBottom: 'none',
    },
  }),
};

export const getTailClassName = (position: PopoverPosition): string => tailClassNames[position];
